import { render, staticRenderFns } from "./emailResend.vue?vue&type=template&id=b35805fa&scoped=true"
import script from "./emailResend.vue?vue&type=script&lang=js"
export * from "./emailResend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35805fa",
  null
  
)

export default component.exports